var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4182"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5",
    width: 32,
    height: 32,
    rx: 16,
    fill: "#C0E709"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5816 11.2285L19.5418 20.1385C19.4458 20.5582 19.0018 20.7743 18.6379 20.5751L16.0581 19.1636L14.8383 21.2788C14.5063 21.8552 13.6664 21.6052 13.6664 20.9312V18.5744C13.6664 18.3921 13.7384 18.2183 13.8624 18.0912L18.8899 13.0045C18.8859 12.941 18.8219 12.8858 18.7579 12.9325L12.7585 17.3578L10.7427 16.2557C10.2707 15.9972 10.2907 15.2723 10.7787 15.0477L20.7177 10.457C21.1936 10.2366 21.7056 10.6901 21.5816 11.2285Z",
    fill: "#1A1A1A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainTelegram);
export default __webpack_public_path__ + "static/media/main-telegram.0ac99501aace87f00e31025630f32646.svg";
export { ForwardRef as ReactComponent };